import { Box, Tooltip } from '@mui/material'

const TooltipWrapper = ({
  children,
  disabled
}: {
  children: React.ReactNode
  disabled?: boolean
}) => {
  if (!disabled) return <>{children}</>

  return (
    <Tooltip
      title="Estas opções só podem ser editadas na recorrência principal. Para fazer alterações, acesse a recorrência."
      followCursor
      placement="top"
    >
      <Box sx={{ width: '100%' }}>{children}</Box>
    </Tooltip>
  )
}

export default TooltipWrapper
